import { ShiftSystem } from '../candidate/shift-system';
import { ShiftType } from './shift-type';

export const SHIFT_TYPE_MATCH_MAP: Record<ShiftType, ShiftSystem[] | null> = {
  [ShiftType.Morning]: [ShiftSystem.EarlyShift, ShiftSystem.TwoShifts, ShiftSystem.ThreeShifts],
  [ShiftType.Evening]: [ShiftSystem.LateShift, ShiftSystem.TwoShifts, ShiftSystem.ThreeShifts],
  [ShiftType.Night]: [ShiftSystem.NightShift, ShiftSystem.ThreeShifts],
  [ShiftType.PermanentNightGuard]: [ShiftSystem.NightWatch],
  [ShiftType.Day]: null,
  [ShiftType.WorkingHours]: null,
};

export const doesShiftSystemMatchShiftType = (
  shiftSystem: ShiftSystem[] | null | undefined,
  shiftType: ShiftType | null | undefined,
): boolean | null => {
  if (!shiftType || !shiftSystem?.length) return null;

  const matchingValues = SHIFT_TYPE_MATCH_MAP[shiftType];
  if (!matchingValues) return null;

  return shiftSystem.some(value => matchingValues.includes(value));
};
